import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { StudioService } from '../../core/services/studio.service';
import { StudioSelectionService } from '../../core/services/studio-selection.service';
import { MemberService } from '../../core/services/member.service';
import { PagerComponent } from '../../shared/components/pager.component';

const SESSION_KEY = 'inout_select_studio_id';

function isoDate(d: Date): string {
  return new JstDate(d.getTime() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

@Component({
    selector: 'app-inout-list',
    imports: [FormsModule, DatePipe, PagerComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ filteredItems.length }} 件)</span></span>
        </div>
        <div class="card-body">
          <!-- 旧版 inout.html:9-12 の card-body 先頭 <flash-message> 相当 -->
          @if (feedback) {
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-dismissible" role="alert"
                  [class.alert-success]="feedback.type === 'success'" [class.alert-danger]="feedback.type === 'danger'">
                  {{ feedback.text }}
                  <button type="button" class="close" aria-label="通知を閉じる" (click)="clearFeedback()"><span aria-hidden="true">&times;</span></button>
                </div>
              </div>
            </div>
          } @else { <div style="height: 1px"></div> }
          <form novalidate name="myForm">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="studio_name">店舗</label>
                    <select class="form-control" id="studio_name" [(ngModel)]="selectedStudio"
                      name="studio_name" (ngModelChange)="onStudioChange()">
                      <option [ngValue]="null">-- 選択してください --</option>
                      @for (studio of studios; track studio.id) {
                        <option [ngValue]="studio">{{ studio.name }}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="datePickerFrom">入退館時間</label>
                    <div class="bisected-input-wrap">
                      <div class="bisected-input">
                        <input id="datePickerFrom" name="date_from" type="date" [(ngModel)]="dateFrom"
                          class="form-control" (ngModelChange)="loadInout()">
                      </div>
                      <div><span>&nbsp;~&nbsp;</span></div>
                      <div class="bisected-input">
                        <input id="datePickerTo" name="date_to" type="date" [(ngModel)]="dateTo"
                          class="form-control" (ngModelChange)="loadInout()">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            @if (showFilterOption) {
              <div class="row" style="align-items: flex-end;">
                <div class="col-md-8">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label" for="keyword">キーワード検索</label>
                      <input id="keyword" name="keyword" type="text" [(ngModel)]="keyword"
                        class="form-control" placeholder="会員ID、会員氏名など"
                        (ngModelChange)="pageIndex = 0">
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                        <i class="fa s-icon-backspace"></i>&nbsp;条件クリア
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </form>
          <hr>
        </div>
        <div class="card-body">
          <div class="form-group row">
            <div class="col-md-12">
              @if (selectedStudio) {
                <button class="btn btn-success" type="button" [disabled]="disableDownload" (click)="openUploadModal()">
                  <div class="file_format_icon up">
                    <div>
                      <span title="csv"></span>
                      <span class="material-icons-outlined">upload</span>
                    </div>
                  </div>
                  &nbsp;アップロード
                </button>
              }
              @if (userPermission <= 1) {
                <button class="btn btn-success" type="button" (click)="showDownloadAllModal = true">
                  <div class="file_format_icon dl">
                    <div>
                      <span title="csv"></span>
                      <span class="material-symbols-outlined align-bottom">add_notes</span>
                    </div>
                  </div>
                  &nbsp;ダウンロード(全店一括)
                </button>
              }
              @if (selectedStudio && items.length > 0) {
                <button class="btn btn-success" type="button" [disabled]="disableDownload" (click)="downloadCsv()">
                  <div class="file_format_icon dl">
                    <div>
                      <span title="csv"></span>
                      <span class="material-icons-outlined">download</span>
                    </div>
                  </div>
                  &nbsp;ダウンロード
                </button>
              }
            </div>
          </div>
          <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
          @if (searching) {
            <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
          }
          @if (selectedStudio && !searching && filteredItems.length === 0) {
            <span>該当するデータはありません</span>
          }
          @if (filteredItems.length > 0) {
            <table class="table table-bordered table-sm table-hover table-ptb-0">
              <thead>
                <tr>
                  <th>会員ID</th>
                  <th>入退館キー</th>
                  <th width="25%">会員氏名(かな)</th>
                  <th>入退館時間</th>
                  <th>入退館</th>
                </tr>
              </thead>
              <tbody>
                @for (item of pagedItems; track item.id) {
                  <tr [class.table-blue]="item.isEntrance === 1">
                    <td>{{ item.member?.memberCode }}</td>
                    <td>{{ item.member?.keyNumber?.keyNumber }}</td>
                    <td>
                      <button type="button" class="btn btn-link border-0 p-0 text-left" style="max-width: 100%; white-space: normal; overflow-wrap: anywhere;" (click)="setSelectMember(item.member)">
                        {{ item.member?.lastName }}&nbsp;{{ item.member?.firstName }}&#040;{{ item.member?.lastNameKana }}&nbsp;{{ item.member?.firstNameKana }}&#041;
                      </button>
                    </td>
                    <td>{{ item.accessedAt | date:'yyyy/MM/dd HH:mm:ss':'+0900' }}</td>
                    <td>
                      @if (item.isEntrance === 0) { <span>入館</span> }
                      @if (item.isEntrance === 1) { <span>退館</span> }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
          <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 会員詳細モーダル -->
@if (showMemberModal) {
  <div class="modal-backdrop fade show" (click)="showMemberModal = false"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="getMemberDetailModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="getMemberDetailModalLabel">会員情報 / 詳細</h5>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <table class="table table-sm table-borderless">
              <tr><th class="text-right" style="width: 40%;">会員ID：</th><td>{{ selectedMember?.memberCode }}</td></tr>
              <tr><th class="text-right">会員氏名（かな）：</th><td>{{ selectedMember?.lastName }} {{ selectedMember?.firstName }}({{ selectedMember?.lastNameKana }} {{ selectedMember?.firstNameKana }})</td></tr>
              <tr><th class="text-right">生年月日：</th><td>{{ selectedMember?.birthday }}</td></tr>
              <tr><th class="text-right">住所：</th><td>〒{{ selectedMember?.zip }}</td></tr>
              <tr><th class="text-right"></th><td>{{ selectedMember?.province }}&nbsp;{{ selectedMember?.city }}</td></tr>
              <tr><th class="text-right"></th><td>{{ selectedMember?.area }}&nbsp;{{ selectedMember?.address }}</td></tr>
              <tr><th class="text-right">電話番号：</th><td>{{ selectedMember?.phone }}</td></tr>
              <tr><th class="text-right">メールアドレス：</th><td>{{ selectedMember?.email }}</td></tr>
              <tr><th class="text-right">コース区分：</th><td>{{ selectedMember?.studioPlan?.name }}</td></tr>
              <tr>
                <th class="text-right">支払方法：</th>
                <td>
                  @if (selectedMember?.payment?.paymentMethod === 0) { <span>口座振替</span> }
                  @if (selectedMember?.payment?.paymentMethod === 1) { <span>クレジット</span> }
                </td>
              </tr>
              <tr><th class="text-right">入退館キー：</th><td>{{ selectedMember?.keyNumber?.keyNumber }}</td></tr>
              <tr><th class="text-right">ロッカー：</th><td>{{ selectedMember?.lockerNumber?.lockerNumber }}</td></tr>
              <tr><th class="text-right">登録日時：</th><td>{{ selectedMember?.createdAt | date:'yyyy/MM/dd HH:mm' }}</td></tr>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showMemberModal = false">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- ファイルアップロードモーダル -->
@if (showUploadModal && selectedStudio) {
  <div class="modal-backdrop fade show" (click)="showUploadModal = false"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">入退館履歴データファイルアップロード</h5>
          <button type="button" class="close" (click)="showUploadModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group row">
            <label class="col-md-4 col-form-label">認証方式</label>
            <div class="col-md-8">
              @if (isSelectableInoutType()) {
                <select class="form-control" [(ngModel)]="uploadInoutType" name="uploadInoutType">
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (opt of selectableInoutTypeOptions; track opt.id) {
                    <option [ngValue]="opt">{{ opt.name }}</option>
                  }
                </select>
              } @else {
                <label class="col-form-label">{{ inoutTypeName(selectedStudio.inoutType) }}</label>
              }
            </div>
          </div>
          <div class="input-group">
            <label class="input-group-btn">
              <span class="btn btn-light">
                <i class="fa s-icon-file"></i>&nbsp;ファイル選択
                <input type="file" class="d-none" accept=".csv,.txt" file-model="myFile" (change)="onUploadFileSelect($event)">
              </span>
            </label>
            <input type="text" class="form-control bg-white border-0" readonly [value]="selectedUploadFile?.name ?? noUploadFileText">
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showUploadModal = false">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-success" type="button" (click)="uploadSelectedFile()"
            [disabled]="!selectedUploadFile || (isSelectableInoutType() && !uploadInoutType) || disableDownload">
            <i class="fa fa-upload"></i>&nbsp;アップロード
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- ダウンロード確認モーダル -->
@if (showDownloadModal) {
  <div class="modal-backdrop fade show" (click)="showDownloadModal = false"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="downloadInoutModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="downloadInoutModalLabel">入退館履歴ダウンロード</h5>
          <button type="button" class="close" (click)="showDownloadModal = false"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">ダウンロードしますか？</div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showDownloadModal = false"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
          <button class="btn btn-success" type="button" (click)="downloadCsv()"><i class="fa s-icon-dawnload"></i>&nbsp;ダウンロード</button>
        </div>
      </div>
    </div>
  </div>
}

<!-- 全店一括ダウンロード確認モーダル -->
@if (showDownloadAllModal) {
  <div class="modal-backdrop fade show" (click)="showDownloadAllModal = false"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="downloadAllMemberDetailModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="downloadAllMemberDetailModalLabel">入退館履歴ダウンロードデータ作成(全店)</h5>
          <button type="button" class="close" (click)="showDownloadAllModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          入退館履歴データを作成します。<br /><br />
          作成後、ダウンロード管理画面からダウンロードが可能です。<br/>
          作成しますか？
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showDownloadAllModal = false">
            <span class="material-symbols-outlined align-bottom">cancel</span>&nbsp;閉じる
          </button>
          <button class="btn btn-success" type="button" (click)="createDownloadData(true)">
            <span class="material-symbols-outlined align-bottom">add_notes</span>&nbsp;はい
          </button>
        </div>
      </div>
    </div>
  </div>
}
  `
})
export class InoutListComponent implements OnInit, OnDestroy {
  private pageTitleService = inject(PageTitleService);
  private authState = inject(AuthStateService);
  private studioService = inject(StudioService);
  private studioSelection = inject(StudioSelectionService);
  private memberService = inject(MemberService);

  get userPermission(): number { return this.authState.currentUser?.role ?? 99; }

  studios: any[] = [];
  selectedStudio: any = null;
  items: any[] = [];
  keyword = '';
  searching = false;
  private inoutRequestId = 0;
  showFilterOption = false;
  disableDownload = false;
  feedback: { type: 'success' | 'danger'; text: string } | null = null;
  private feedbackTimer?: ReturnType<typeof setTimeout>;
  dateFrom: string;
  dateTo: string;

  // Pagination
  readonly pageLimit = 300;
  pageIndex = 0;

  // Modals
  showMemberModal = false;
  selectedMember: any = null;
  showDownloadAllModal = false;
  showDownloadModal = false;
  showUploadModal = false;
  selectedUploadFile: File | null = null;
  readonly noUploadFileText = '\u9078\u629e\u3055\u308c\u3066\u3044\u307e\u305b\u3093';
  uploadInoutType: any = null;
  readonly inoutTypeOptions = [
    { id: 0, name: '物理キー' },
    { id: 1, name: '顔認証' },
    { id: 9, name: '都度選択' },
  ];
  readonly selectableInoutTypeOptions = this.inoutTypeOptions.filter(opt => opt.id !== 9);

  constructor() {
    const now = new JstDate();
    this.dateTo = isoDate(now);
    this.dateFrom = this.dateTo.slice(0, 7) + '-01';
  }

  get filteredItems(): any[] {
    return this.items.filter(item => matchesNestedKeyword(item, this.keyword));
  }

  get pagedItems(): any[] {
    return this.filteredItems.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }

  get totalPages(): number { return Math.ceil(this.filteredItems.length / this.pageLimit); }

  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  async clearFilter(): Promise<void> {
    this.keyword = '';
    this.pageIndex = 0;
    this.dateTo = isoDate(new JstDate());
    this.dateFrom = this.dateTo.slice(0, 7) + '-01';
    await this.loadInout();
  }

  setSelectMember(member: any): void {
    this.selectedMember = member;
    this.showMemberModal = true;
    if (member?.id) {
      void this.loadMemberDetail(member.id);
    }
  }

  private async loadMemberDetail(memberId: number): Promise<void> {
    try {
      this.selectedMember = await this.memberService.getOne(memberId);
    } catch {
      // Historical in/out rows can reference members no longer available via the detail API.
    }
  }

  inoutTypeName(type: number | string): string {
    return this.inoutTypeOptions.find(opt => Number(opt.id) === Number(type))?.name ?? '';
  }

  isSelectableInoutType(): boolean {
    return Number(this.selectedStudio?.inoutType) === 9;
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員管理', 's-icon-members');
    this.studios = await this.studioService.list('all') ?? [];
    const restored = this.studioSelection.restore(this.studios, SESSION_KEY);
    if (restored) {
      this.selectedStudio = restored;
      await this.loadInout();
    }
  }

  async onStudioChange(): Promise<void> {
    this.items = [];
    this.showFilterOption = false;
    if (!this.selectedStudio) this.studioSelection.clear(SESSION_KEY);
    else this.studioSelection.save(this.selectedStudio, SESSION_KEY);
    await this.loadInout();
  }

  async loadInout(): Promise<void> {
    const requestId = ++this.inoutRequestId;
    this.items = [];
    this.showFilterOption = false;
    this.pageIndex = 0;
    if (!this.selectedStudio || !this.dateFrom || !this.dateTo) {
      this.searching = false;
      return;
    }
    const start = new JstDate(`${this.dateFrom}T00:00:00+09:00`);
    const end = new JstDate(new JstDate(`${this.dateTo}T00:00:00+09:00`).getTime() + 86400000);
    if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime())) {
      this.searching = false;
      return;
    }
    this.searching = true;
    try {
      const data = await this.studioService.getInout(
        this.selectedStudio.id,
        start.toISOString(),
        end.toISOString()
      ) ?? [];
      if (requestId !== this.inoutRequestId) return;
      this.items = data;
      this.showFilterOption = data.length > 0;
      this.pageIndex = 0;
    } finally {
      if (requestId === this.inoutRequestId) this.searching = false;
    }
  }

  downloadCsv(): void {
    if (this.disableDownload) return;
    this.disableDownload = true;
    try {
      this.showDownloadModal = false;
      const headers = ['店舗名', '会員ID', '入退館キー', '氏名', '氏名(かな)', '入退館時間', '入退館'];
      const escape = (v: string | null | undefined) =>
        `"${(v ?? '').replace(/\r\n|\n/g, '').replace(/,/g, '，').replace(/"/g, '""')}"`;
      const rows = this.filteredItems.map(item => {
        const d = item.accessedAt ? new JstDate(item.accessedAt) : null;
        const fmt = (n: number) => String(n).padStart(2, '0');
        const dateStr = d
          ? `${d.getFullYear()}/${fmt(d.getMonth() + 1)}/${fmt(d.getDate())} ${fmt(d.getHours())}:${fmt(d.getMinutes())}`
          : '';
        return [
          escape(item.member?.studio?.name),
          escape(item.member?.memberCode),
          escape(item.member?.keyNumber?.keyNumber),
          escape((item.member?.lastName ?? '') + ' ' + (item.member?.firstName ?? '')),
          escape((item.member?.lastNameKana ?? '') + ' ' + (item.member?.firstNameKana ?? '')),
          escape(dateStr),
          escape(item.isEntrance === 0 ? '入館' : item.isEntrance === 1 ? '退館' : ''),
        ].join(',');
      });
      const bom = '﻿';
      const csv = bom + [headers.map(escape).join(','), ...rows].join('\r\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${Date.now()}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setTimeout(() => { this.disableDownload = false; }, 500);
    }
  }

  openUploadModal(): void {
    if (!this.selectedStudio) return;
    this.selectedUploadFile = null;
    this.uploadInoutType = null;
    this.showUploadModal = true;
  }

  onUploadFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selectedUploadFile = input.files?.[0] ?? null;
  }

  async uploadSelectedFile(): Promise<void> {
    if (!this.selectedUploadFile || !this.selectedStudio || this.disableDownload ||
        (this.isSelectableInoutType() && !this.uploadInoutType)) return;
    const fd = new FormData();
    fd.append('file', this.selectedUploadFile);
    const isFr = this.isSelectableInoutType()
      ? !!Number(this.uploadInoutType?.id)
      : !!Number(this.selectedStudio.inoutType);
    this.disableDownload = true;
    try {
      const result = await this.studioService.addInout(this.selectedStudio.id, fd, isFr);
      this.showUploadModal = false;
      this.setFeedback(result?.failed ? 'danger' : 'success', result?.failed || '入退館履歴を登録しました。');
      await this.loadInout();
    } catch {
      // error handled by ApiService (navigates to error page)
    } finally {
      this.disableDownload = false;
    }
  }

  async createDownloadData(isAll = false): Promise<void> {
    const studioId = isAll ? 'all' : this.selectedStudio?.id;
    if (!studioId) return;
    this.showDownloadAllModal = false;
    const error = await this.studioService.createInoutCsv(studioId);
    this.setFeedback(error ? 'danger' : 'success', error || 'データ作成を開始しました。');
  }

  private setFeedback(type: 'success' | 'danger', text: string): void {
    this.clearFeedback();
    this.feedback = { type, text };
    this.feedbackTimer = setTimeout(() => this.clearFeedback(), 5000);
  }

  clearFeedback(): void {
    if (this.feedbackTimer !== undefined) clearTimeout(this.feedbackTimer);
    this.feedbackTimer = undefined;
    this.feedback = null;
  }

  ngOnDestroy(): void {
    this.clearFeedback();
  }
}
